import CuaLoading from "@/components/CuaLoading.vue";
export default {
  name: "App",
  components: {
    "cua-loading": CuaLoading
  }
};